module.exports = __webpack_public_path__ + "platform-web/static/media/now.519cd0e7.svg";